<template>
  <page>
    <div class="ab-screen">
      <div class="column">
        <div class="h1">Get paid for your online data</div>
        <div class="h4">
          Don't
          <span class="strong">give</span> your data to Big Tech firms,
          <span class="strong">rent</span> it directly to advertisers and make them pay you for it.
        </div>
        <img src="/img/m1.jpg" />
      </div>
      <div class="column">
        <sign-up-form />
      </div>
    </div>
  </page>
</template>

<script>
import Page from '@/components/common/Page.vue';
import SignUpForm from './SignUpForm.vue';

export default {
  components: {
    SignUpForm,
    Page,
  },
};
</script>

<style lang="scss" scoped>
@import './common.scss';

.ab-screen {
  background-color: $ab-blue;
  min-height: 100vh;
  width: 100vw;
  flex-direction: row;
  color: white;
  display: flex;
  padding: 0 40px;
}
img {
  width: 495px;
  height: 330px;
}

.h1 {
  font-size: 82px;
  margin: 30px 10px;
  letter-spacing: -4pt;
  font-family: $ab-font-montserrat;
}

.h4 {
  font-size: 20px;
  margin: 30px;
  font-family: $ab-font-montserrat;
  letter-spacing: 0.8pt;
  line-height: 26px;
}

.h1,
.h4 {
  text-align: center;
  color: white;
}

.strong {
  font-weight: bold;
  font-style: italic;
}

.column {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.column:nth-child(1) {
  width: 55vw;
  margin-right: 40px;
  padding: 100px;
}
</style>
